import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ImagePreviewItem } from '../../model';

@UntilDestroy()
@Component({
  selector: 'ip-image-strip',
  templateUrl: './image-strip.component.html',
  styleUrls: ['./image-strip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageStripComponent implements OnInit, OnChanges {
  @Input() items: ImagePreviewItem[] = [];
  @Input() activeId: string;
  @Output() detail = new EventEmitter<ImagePreviewItem>();
  @ViewChild(CdkVirtualScrollViewport, { static: true }) viewPort: CdkVirtualScrollViewport;

  private _activeIndex = -1;
  itemSize = 96;

  ngOnInit(): void {
    this.viewPort.renderedRangeStream.pipe(untilDestroyed(this)).subscribe(() => {
      this.updateScroll();
    });
  }

  ngOnChanges() {
    this.updateScroll();
  }

  private updateScroll(): void {
    if (!this.activeId) return;

    const activeIndex = this.items.findIndex((item) => item.id === this.activeId);

    if (this._activeIndex === activeIndex || this.viewPort.getViewportSize() === 0) {
      return;
    }

    this._activeIndex = activeIndex;

    const offset = this.itemSize * this._activeIndex - this.viewPort.getViewportSize() / 2 + this.itemSize / 2;
    this.viewPort.scrollToOffset(offset);
  }
}
